import type { FC } from "react";
import Navbar from "./Navbar";
import rupeeWatermark from "../assets/loanInMinutes/Rupee.png";
import symbolWatermark from "../assets/loanInMinutes/symbol_1.png";
import stepsoverlap from "../assets/loanInMinutes/divsteps.png";

const SearchIcon: FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M32.375 6.16667C37.2959 6.16634 42.1175 7.55141 46.2879 10.1634C50.4584 12.7753 53.8093 16.5087 55.957 20.9361C58.1048 25.3636 58.9627 30.3062 58.4326 35.1985C57.9024 40.0907 56.0057 44.7349 52.9593 48.5995L64.2197 59.8598C64.7813 60.4414 65.0921 61.2202 65.0851 62.0287C65.078 62.8371 64.7538 63.6104 64.1821 64.1821C63.6104 64.7538 62.8371 65.078 62.0287 65.0851C61.2202 65.0921 60.4414 64.7813 59.8598 64.2197L48.5995 52.9593C45.3171 55.5461 41.4637 57.3105 37.3608 58.1051C33.2579 58.8998 29.0244 58.7018 25.0136 57.5276C21.0028 56.3534 17.3309 54.2371 14.3043 51.3552C11.2777 48.4732 8.98424 44.9094 7.61515 40.9608C6.24606 37.0122 5.84109 32.7935 6.43402 28.6566C7.02695 24.5197 8.60058 20.5846 11.0236 17.1796C13.4467 13.7745 16.6489 10.9983 20.3631 9.08256C24.0773 7.16679 28.1958 6.16702 32.375 6.16667ZM32.375 12.3333C27.0596 12.3333 21.9619 14.4449 18.2034 18.2034C14.4449 21.9619 12.3333 27.0596 12.3333 32.375C12.3333 37.6904 14.4449 42.7881 18.2034 46.5466C21.9619 50.3051 27.0596 52.4167 32.375 52.4167C37.6904 52.4167 42.7881 50.3051 46.5466 46.5466C50.3051 42.7881 52.4167 37.6904 52.4167 32.375C52.4167 27.0596 50.3051 21.9619 46.5466 18.2034C42.7881 14.4449 37.6904 12.3333 32.375 12.3333ZM32.375 15.4167C36.8726 15.4167 41.186 17.2033 44.3664 20.3836C47.5467 23.564 49.3333 27.8774 49.3333 32.375C49.3333 36.8726 47.5467 41.186 44.3664 44.3664C41.186 47.5467 36.8726 49.3333 32.375 49.3333C27.8774 49.3333 23.564 47.5467 20.3836 44.3664C17.2033 41.186 15.4167 36.8726 15.4167 32.375C15.4167 27.8774 17.2033 23.564 20.3836 20.3836C23.564 17.2033 27.8774 15.4167 32.375 15.4167Z" fill="currentColor" />
  </svg>
);

const FaMobileAlt: FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 48 46" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M32.808 0H14.6939C13.4965 0 12.3481 0.475681 11.5014 1.3224C10.6546 2.16912 10.179 3.31751 10.179 4.51495V40.7228C10.179 43.2178 12.2012 45.24 14.6939 45.24H32.8057C34.0034 45.24 35.152 44.7644 35.9991 43.9177C36.8462 43.0711 37.3224 41.9227 37.323 40.725V4.51495C37.323 3.31751 36.8473 2.16912 36.0006 1.3224C35.1538 0.475681 34.0054 0 32.808 0ZM23.751 42.978C22.1902 42.978 20.9235 41.9669 20.9235 40.716C20.9235 39.4651 22.1902 38.454 23.751 38.454C25.3117 38.454 26.5785 39.4651 26.5785 40.716C26.5785 41.9669 25.3117 42.978 23.751 42.978ZM32.799 36.192H14.703V4.524H32.799V36.192Z" fill="#E53935" />
  </svg>


);

const FaIdCard: FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 87 66" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M24.504 26.7303H32.3409M24.504 39.2695H32.3409M44.8801 43.9716C44.8801 41.4774 45.8709 39.0854 47.6345 37.3218C49.3982 35.5581 51.7902 34.5673 54.2844 34.5673M54.2844 34.5673C56.7786 34.5673 59.1706 35.5581 60.9343 37.3218C62.6979 39.0854 63.6888 41.4774 63.6888 43.9716M54.2844 34.5673C55.9472 34.5673 57.5419 33.9067 58.7177 32.731C59.8934 31.5552 60.554 29.9605 60.554 28.2977C60.554 26.6349 59.8934 25.0402 58.7177 23.8645C57.5419 22.6887 55.9472 22.0282 54.2844 22.0282C52.6216 22.0282 51.0269 22.6887 49.8512 23.8645C48.6754 25.0402 48.0148 26.6349 48.0148 28.2977C48.0148 29.9605 48.6754 31.5552 49.8512 32.731C51.0269 33.9067 52.6216 34.5673 54.2844 34.5673ZM11.9648 56.6193V9.38052C11.9648 8.5748 12.618 7.92163 13.4237 7.92163H73.2016C74.0073 7.92163 74.6605 8.5748 74.6605 9.38052V56.6193C74.6605 57.425 74.0073 58.0782 73.2016 58.0782H13.4237C12.618 58.0782 11.9648 57.425 11.9648 56.6193Z" stroke="#E53935" stroke-width="6.26957" stroke-linecap="square" />
  </svg>

);

const FaRupeeSign: FC<{ className?: string }> = () => (
  <svg width="63" height="71" viewBox="0 0 63 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M48.5383 20.7076C52.4576 19.8373 57.5625 15.9472 58.3394 14.0314C58.795 12.91 56.5229 11.1577 55.9154 10.4509C54.5253 8.83885 55.086 8.04448 55.6234 6.12283C56.2367 3.93833 54.7823 1.52604 52.7204 0.579813C50.6586 -0.366412 48.1937 -0.0685264 46.1202 0.854336C44.0467 1.7772 42.2769 3.26079 40.5422 4.72101C39.2747 3.92081 37.2537 0.387064 33.9828 2.68254C31.7224 4.26542 31.518 7.71155 31.81 10.4626C32.4934 16.8117 34.0588 20.1059 37.0084 20.9938C40.7349 22.1152 44.8586 21.5253 48.5383 20.7076Z" fill="#FFCA28" />
    <path d="M54.9049 2.44306C54.4085 11 46.0618 16.6773 42.1017 19.1772L44.6717 21.3851C44.6717 21.3851 46.3013 21.4201 48.5325 20.7076C52.3583 19.4926 57.948 16.0582 58.3335 14.0314C58.9001 11.0818 55.8745 11.7243 55.1911 9.39373C54.8348 8.1613 56.9259 5.83078 54.9049 2.44306ZM40.548 4.72685C40.548 4.72685 39.0586 3.20238 37.9546 2.50731C37.4056 3.54115 37.0143 4.6626 36.8215 5.8191C36.4769 7.85173 36.8215 10.7371 37.6334 12.8866C37.7619 13.2195 38.2408 13.167 38.2934 12.8165C38.9943 8.19635 40.548 4.72685 40.548 4.72685Z" fill="#E2A610" />
    <path d="M30.1395 19.9541C30.1395 19.9541 11.9217 21.9225 3.7036 37.7396C-4.51455 53.5568 2.47117 63.1475 9.86575 66.6404C17.2603 70.1333 35.8928 71.3657 48.0127 68.492C60.1325 65.6182 63.164 59.6605 62.5974 53.9072C61.7738 45.508 53.9704 40.3447 53.9704 40.3447C53.9704 40.3447 54.28 29.9712 46.2312 23.2367C39.0878 17.2556 30.1395 19.9541 30.1395 19.9541Z" fill="#FFCA28" />
    <path d="M41.6519 16.3327C46.5816 17.939 47.6739 22.3956 47.3176 23.6105C46.8912 25.0357 41.43 19.4868 33.3111 19.8197C30.4724 19.9366 31.296 18.196 32.6102 17.1913C34.345 15.8654 37.2596 14.9075 41.6519 16.3327Z" fill="#6D4C41" />
    <path d="M41.6519 16.3327C46.5816 17.939 47.6739 22.3956 47.3176 23.6105C46.8912 25.0357 41.43 19.4868 33.3111 19.8197C30.4724 19.9366 31.296 18.196 32.6102 17.1913C34.345 15.8654 37.2596 14.9075 41.6519 16.3327Z" fill="#6B4B46" />
    <path d="M50.3081 32.0447C50.9273 31.6184 53.0066 32.3543 53.5907 36.4254C53.8769 38.4172 53.9645 40.3447 53.9645 40.3447C53.9645 40.3447 51.5114 38.1426 50.6995 36.5948C49.6773 34.6381 49.2801 32.7457 50.3081 32.0447Z" fill="#E2A610" />
    <path d="M40.6709 36.1921L41.258 33.8986L27.4966 30.3761L26.9095 32.6696L31.4967 33.8438C33.6297 34.3898 35.0315 36.3127 35.0426 38.4172L26.0289 36.11L25.4418 38.4035L34.4555 40.7108C33.4346 42.5512 31.2813 43.564 29.1483 43.0181L25.708 42.1374C25.2263 42.0141 24.7257 42.2037 24.4392 42.6069C24.1527 43.0101 24.1497 43.547 24.4374 43.9506L31.5569 54.3264L33.5109 52.9937L28.1713 45.2118L28.5612 45.3116C31.9672 46.1834 35.4252 44.417 36.8064 41.3125L39.2032 41.926L39.7903 39.6325L37.3935 39.019C37.503 37.6823 37.2318 36.342 36.6113 35.153L40.6709 36.1921Z" fill="#6B4B46" />
  </svg>

);

const steps: {
  Icon: FC<{ className?: string }>;
  filled: boolean;
  title: string;
  titleRed: boolean;
  desc: string;
}[] = [
    {
      Icon: SearchIcon,
      filled: false,
      title: "Check Eligibility",
      titleRed: false,
      desc: "Enter a few basic details to instantly see if you qualify and what amount you're eligible for.",
    },
    {
      Icon: FaMobileAlt,
      filled: false,
      title: "Complete Application",
      titleRed: false,
      desc: "Fill in your personal, employment, and banking details. The whole form takes under 5 minutes.",
    },
    {
      Icon: FaIdCard,
      filled: false,
      title: "Verify Documents",
      titleRed: false,
      desc: "Upload your KYC documents digitally. Our system verifies them instantly — no physical submission needed.",
    },
    {
      Icon: FaRupeeSign,
      filled: true,
      title: "Receive Funds",
      titleRed: true,
      desc: "Once approved, funds are transferred directly to your bank account — sometimes within seconds.",
    },
  ];

export const HowItWorksSection = () => {
  return (
    <section className="relative overflow-hidden py-10">
      {/* Rupee watermark — top left */}
      <img
        src={rupeeWatermark}
        alt=""
        className="absolute top-3 sm:top-8 left-5 w-15 h-15 sm:w-48 sm:h-48 object-contain opacity-80 pointer-events-none select-none"
      />
      {/* Symbol watermark — top right */}
      <img
        src={symbolWatermark}
        alt=""
        className="absolute top-0 -right-5 sm:-right-10 w-30 h-30  sm:w-64 sm:h-64 object-contain opacity-100 pointer-events-none select-none"
      />

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-10 lg:mb-16">
          <span className="text-[#CC1A1A] text-xs font-black tracking-[0.3em] uppercase mb-3">
            THE PROCESS
          </span>
          <div className="w-8 h-0.5 bg-[#CC1A1A] mb-5" />
          <h2 className="text-4xl xl:text-5xl font-bold text-[#1a1a4e] mb-4">
            Four Steps To Faster Funding
          </h2>
          <p className="text-gray-400 font-light text-base">
            The fastest path from application to approved funds. No queues, no branches, no nonsense.
          </p>
        </div>

        {/* ── MOBILE LAYOUT ── */}
        <div className="lg:hidden">
          {/* Overlapping circles row */}
          {/* <div className="flex items-center justify-center mb-12">
            {steps.map((step, i) => (
              <div
                key={i}
                className={`w-[100px] h-[100px] rounded-full border-4 border-[#CC1A1A] flex items-center justify-center flex-shrink-0 ${
                  step.filled ? "bg-[#CC1A1A]" : "bg-white"
                }`}
                style={{ marginLeft: i > 0 ? "-22px" : "0", zIndex: i + 1 }}
              >
                <step.Icon
                  className={`text-3xl ${step.filled ? "text-white" : "text-[#CC1A1A]"}`}
                />
              </div>
            ))}
          </div> */}

          <img src={stepsoverlap} alt="step" className="-mt-8" />

          {/* Alternating step list */}
          <div className="flex flex-col">
            {steps.map((step, i) => {
              const isEven = i % 2 === 0;
              return (
                <div
                  key={i}
                  className={`flex items-center gap-4 py-2 ${isEven ? "flex-row" : "flex-row-reverse"}`}
                >
                  {/* Text */}
                  <div className="flex-1">
                    <h3
                      className={`font-medium text-xl mb-2 ${step.titleRed ? "text-[#CC1A1A]" : "text-[#111112]"
                        }`}
                    >
                      {step.title}
                    </h3>
                    <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
                  </div>
                  {/* Large faded icon */}
                  <div className="w-24 h-24 flex items-center justify-center flex-shrink-0 opacity-20">
                    <step.Icon className="text-[80px] text-[#a40909]" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* ── DESKTOP LAYOUT ── */}
        <div className="hidden lg:block">
          <div className="relative flex flex-row items-start justify-between">
            {/* Connecting line */}
            <div className="absolute top-[52px] left-[12.5%] right-[12.5%] h-[4px] bg-[#CC1A1A] z-0" />

            {steps.map((step, i) => (
              <div key={i} className="flex flex-col items-center text-center w-1/4 relative z-10">
                <div
                  className={`w-[104px] h-[104px] rounded-full flex items-center justify-center mb-6 border-4 border-[#CC1A1A] ${step.filled ? "bg-[#CC1A1A]" : "bg-white"
                    }`}
                >
                  <step.Icon
                    className={`h-12 ${step.filled ? "text-white" : "text-[#CC1A1A]"}`}
                  />
                </div>
                <h3
                  className={`text-lg font-bold mb-3 ${step.titleRed ? "text-[#CC1A1A]" : "text-[#121215]"
                    }`}
                >
                  {step.title}
                </h3>
                <p className="text-gray-500 text-base leading-relaxed max-w-[200px]">
                  {step.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const HowItWorks = () => {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <div className="pt-[73px]">
        <HowItWorksSection />
      </div>
    </div>
  );
};

export default HowItWorks;
